import { MATRIX_BACKEND } from '@/remotes';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { getProperDate } from '@/utils/changeDate';

export async function useFetchAvailablePickUpTime() {
  const dataForm = useNewDataFormCargoPickUpStore();

  const { cargoInformation } = dataForm;

  const params = new URLSearchParams();
  const city = dataForm.sender.cityFrom;

  const weight = Number(cargoInformation.cargoWeight);

  if (!city) {
    dataForm.fetchedAvailablePickupTime = [];
    return;
  }
  const { id: cargoTypeId } = dataForm.cargoInformation.typeOfCargo;

  params.append('cityId', city.id);
  params.append('date', getProperDate(new Date()));
  params.append('cargoType', cargoTypeId);

  const cargoDimensions = cargoInformation.cargoDimensions;
  const sizeOfCargoCylinder = dataForm.cargoInformation.sizeOfCargoCylinder;

  switch (cargoTypeId) {
    case 1:
      if (dataForm.getIsValidStandard) {
        params.append('weight', weight);

        params.append('length', Number(cargoDimensions.length));
        params.append('width', Number(cargoDimensions.width));
        params.append('height', Number(cargoDimensions.height));
      } else {
        dataForm.fetchedAvailablePickupTime = [];
        return;
      }
      break;
    case 2:
      if (dataForm.getIsValidCylinder) {
        params.append('weight', weight);

        params.append('diameter', Number(sizeOfCargoCylinder.diameter));
        params.append('height', Number(sizeOfCargoCylinder.height));
      } else {
        dataForm.fetchedAvailablePickupTime = [];
        return;
      }
      break;

    default:
      break;
  }

  try {
    // #TODO
    dataForm.fetchedAvailablePickupTime = (await MATRIX_BACKEND.get('/api/public/available-pick-up-time', { params })).data;
  } catch {
    dataForm.fetchedAvailablePickupTime = [];
  }
}
